import React, {Component} from "react";

import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_MAIN_PROJECT_NAME,
    ATTR_AWS_PROJECT_ID,
    ATTR_PROJECT_STATE,
    ATTR_TEXT,
    OBJ_STATE_ACT,
    OBJ_STATE_PAS,
    ATTR_CUSTOMER_GROUP,
    OBJ_STATE_CREATE, ATTR_MAIN_PROJ_ID,
    prosLogErr, prosLog, getObjAttr, userHasMainProjects, ATTR_OBJ_STATE, ATTR_OBJ_ID, OBJ_TYPE_PRJ, ATTR_IS_TEMPLATE,
    ATTR_IS_EXAMPLE, STR_YES, isSuperUserModeInUse
} from "../prodect/ProsConnect";

import {isProsStringEmpty, prosMultiFilterText, makeUiMainProjectList} from "../prodect/ProsCommonUi";
import {prosPopupCloseAll} from "../prodect/ProsPopup";
import BasicButton from "../components/BasicButton";
import LoadingAnimation from "../components/LoadingAnimation";
import DropdownMenu from "../components/DropdownMenu";
import {
    MAIN_VIEW_CREATE_NEW_SUBPROJECT, MAIN_VIEW_MAIN_PRJ_SETTINGS,
    MAIN_VIEW_PROJECT_DASHBOARD
} from "./Home";
import prosAppNotif, {prosAppNotifDismiss} from "../prodect/ProsAppNotif";
import TextButton from "../components/TextButton";
import BasicModal from "../components/BasicModal";

var gloSavedProjectNameFilter = ''
var gloSavedProjectView = OBJ_STATE_ACT

let waitProjectActivationTimer = undefined
let isProjectsMounted = false
const POLL_AWS_NOT_BUSY_MS = 200

export default class ProjectsList extends Component {
    constructor(props) {
        super(props);
        this.originalSubProjectMainProjects = []
        this.state = {
            isLoading: true,
            projectName: '',
            projectFilterText: '',
            mainProjects: [],
            filteredList: [],
            isRefresh: false,
            mainProjectCreateCopyUsers: false,
            mainProjectCreateWithReports: false,
            mainProjectCreateWithObs: false,
            newMainProjectName: '',
            customerGroup: '',
            pendingMainProject: false,
            srcProjDrag: null,
            projectView: gloSavedProjectView,
            countViewProjects: '-(-)',
            pendingProjectId: undefined,
            openAll: false,
            isReordering: false,
            currentMainProjectId: props.mainProjectId //only used for showing selected main project
        }
   }

    async componentDidMount() {
        prosLog("Projects::componentDidMount() ++");
        this.setState({
            projectFilterText: gloSavedProjectNameFilter,
            projectView: gloSavedProjectView,
        })
        isProjectsMounted = true
        await this.loadProjects()
        prosConnect.subscribe_notifyProjectListUpdated(this, "Projects")
    }

    componentWillUnmount() {
        prosLog("Projects::componentWillUnmount() --")
        isProjectsMounted = false
        if (waitProjectActivationTimer) {
            this.cancelProjectActivationTimer()
        }
        gloSavedProjectNameFilter = this.state.projectFilterText
        gloSavedProjectView = this.state.projectView
        prosConnect.unsubscribe_notifyProjectListUpdated(this, "Projects")
    }

    async loadProjects(forceFetch) {
        if (!isProjectsMounted) {
            return
        }
        this.setState({
            isLoading: true
        })
        try {
            if (prosConnect.getUserEmail()) {
                await this.makeMainProjectList(this.state.projectView, forceFetch)
            } else {
                // should not happen
                prosLogErr('Projects/loadProjects() missing email')
                alert("User not signed in?")
            }
        } catch (e) {
            alert("Failed to load projects: " + e.message)
        }
        this.setState({
            isLoading: false
        })
    }

    notifyProjectListUpdated() {
        // when some component updated project list - prosConnect will notify to refresh this ui
        this.refreshProjects(false)
    }

    /**
     * Construct main project list from list of projects and update to state
     * @param projectView   New list mode - active, archived or all
     * @param forceFetch    Force to fetch from server
     */
    async makeMainProjectList(projectView, forceFetch) {
        let mainProjectsList = await makeUiMainProjectList(projectView, '',
            true, true, forceFetch)
        let subProjectCount = 0
        mainProjectsList.forEach(mainProj => {
            subProjectCount += mainProj.projects.length
        })
        this.setState({
            mainProjects: mainProjectsList,
            filteredList: this.getFilteredMainProjects(mainProjectsList, this.state.projectFilterText),
            countViewProjects: `${mainProjectsList.length} (${subProjectCount})`,
            projectView: projectView
        })
        this.saveOriginalMainProject(mainProjectsList)
    }

    // Save original main project if
    saveOriginalMainProject(mainProjectsList) {
        this.originalSubProjectMainProjects.length = 0
        mainProjectsList.forEach(mainProj => {
            mainProj.projects.forEach(proj => {
                this.originalSubProjectMainProjects.push({
                    [ATTR_AWS_PROJECT_ID]: proj[ATTR_AWS_PROJECT_ID],
                    [ATTR_MAIN_PROJ_ID]: proj[ATTR_MAIN_PROJ_ID],
                    [ATTR_MAIN_PROJECT_NAME]: proj[ATTR_MAIN_PROJECT_NAME],
                    [ATTR_CUSTOMER_GROUP]: proj[ATTR_CUSTOMER_GROUP],
                })
            })
        })
    }

    getFilteredMainProjects(mainProjects, filterText) {
        if (isProsStringEmpty(filterText)) {
            // No text filter - get all and open main project that contains active sub project
            mainProjects.forEach(mp => {
                let activeProjectInd = mp.projects
                    .findIndex(project => prosConnect.isProjectActive(project[ATTR_AWS_PROJECT_ID]))
                mp.ui_isOpen = activeProjectInd !== -1
            })
            return mainProjects
        }
        let filtered = []
        mainProjects.forEach(mainProject => {
            // Add main project as a complete when main project name match with a search string
            if(prosMultiFilterText(filterText, mainProject.name)) {
                mainProject.ui_isOpen = true
                // take all subprojects
                filtered.push(mainProject)
            } else {
                // take only those subprojects which has a name match
                let partialMainProject = Object.assign({}, mainProject)
                partialMainProject.projects = mainProject.projects
                    .filter(project => prosMultiFilterText(filterText, project[ATTR_TEXT]))
                if (partialMainProject.projects.length) {
                    partialMainProject.ui_isOpen= true
                    filtered.push(partialMainProject)
                }
            }
        })
        return filtered
    }

    async refreshProjects(forceRetch) {
        if (!isProjectsMounted) {
            return
        }
        this.setState({ isRefresh: true });
        await this.loadProjects(forceRetch)
        if (!isProjectsMounted) {
            return
        }
        this.setState({ isRefresh: false });
    }

    getProjectUiClass(project) {
        let pid = project[ATTR_AWS_PROJECT_ID]
        if (this.state.pendingProjectId === pid) {
            return " loading"
        }
        const isExample = project[ATTR_IS_EXAMPLE] || false
        return (prosConnect.isProjectActive(pid) ? " selected" : "")
            + (isExample ? " example" : "")
            + (project[ATTR_IS_TEMPLATE] === STR_YES && !isExample ? " template" : "")
    }

    setTextFilter(newFilterText) {
        if (newFilterText === '') {
            this.state.mainProjects.forEach(mp => mp.ui_isOpen = false);
        }
        let filtered = this.getFilteredMainProjects(this.state.mainProjects, newFilterText);
        this.setState({
            filteredList: filtered,
            projectFilterText: newFilterText
        })
    }

    onDragStartProj(ev, proj) {
        ev.stopPropagation()   // required as subproject is a child element of main project
        prosLog('onDragStartProj()', this.isMainProject(proj) ? proj.name : proj.text)
        this.setState({srcProjDrag: proj})
    }

    isMainProject(project) {
        return Array.isArray(project.projects)
    }

    /**
     * Dropping is allowed to same type project - main or sub - and not for self
     * @param dropObj
     */
    isValidDrop(dropObj) {
        if(!dropObj || !this.state.srcProjDrag) {
            return false
        }
        if (dropObj.obj_type) {
            // Do not allow dragging report, obs etc report items into project list
            return false
        }
        const isSrcMainProject = this.isMainProject(this.state.srcProjDrag)
        const isDstMainProject = this.isMainProject(dropObj)
        if ((isSrcMainProject === isDstMainProject) ||
            (!isSrcMainProject && isDstMainProject)) {
            // Prevent dropping on top of self
            let srcId = isSrcMainProject ? this.state.srcProjDrag.mainProjectId : this.state.srcProjDrag[ATTR_AWS_PROJECT_ID]
            let dstId = isDstMainProject ? dropObj.mainProjectId : dropObj[ATTR_AWS_PROJECT_ID]
            return srcId !== dstId
        }
        return false
    }

    moveMainProject(movedProj, projectAfter) {
        let newList = this.state.filteredList.filter(mainProj => mainProj.mainProjectId !== movedProj.mainProjectId)
        let afterProjectIndex = newList.findIndex(project => project.mainProjectId === projectAfter.mainProjectId)
        if (afterProjectIndex < 0) {
            prosLogErr("Main project not found movedProj:", movedProj, "projectAfter:", projectAfter)
            return
        }
        afterProjectIndex += 1
        if (afterProjectIndex >= newList.length) {
            newList.push(movedProj)
        } else {
            newList.splice(afterProjectIndex, 0, movedProj)
        }
        this.setState({filteredList: newList})
    }

    /**
     * Move a sub project locally from old main project to a new one.
     * Actual movement will be stored after rearrange is completed
     * @param oldMain       -- old main project
     * @param newMain       -- new main project
     * @param movedProj     -- sub project to be moved
     * @param projectAfter  -- sub project after which to move - when missing (undefined) set as first
     */
    moveSubProjectToMain(oldMain, newMain, movedProj, projectAfter) {
        if (!oldMain ||!newMain) {
            prosLogErr("Main project not found movedProj:", movedProj, "projectAfter:", projectAfter)
            return
        }
        if (!oldMain.projects.find(project => project[ATTR_AWS_PROJECT_ID] === movedProj[ATTR_AWS_PROJECT_ID])) {
            prosLogErr("Sub project not found for movedProj:", movedProj, "in main:", oldMain)
            return
        }
        // Set new main project, remove from old main project and set first
        // Will be moved to correct place when continue from this function
        movedProj[ATTR_MAIN_PROJ_ID] = newMain.mainProjectId
        movedProj[ATTR_MAIN_PROJECT_NAME] = newMain.name
        oldMain.projects = oldMain.projects
            .filter(project => project[ATTR_AWS_PROJECT_ID] !== movedProj[ATTR_AWS_PROJECT_ID])
        newMain.projects.splice(0, 0, movedProj)
        this.setState({filteredList: [].concat(this.state.filteredList)})
    }

    moveSubProjectAfter(movedProj, projectAfter) {
        let newList = [].concat(this.state.filteredList)
        let mainProject1 = newList.find(mainProj => mainProj.mainProjectId === movedProj[ATTR_MAIN_PROJ_ID])
        let mainProject2 = newList.find(mainProj => mainProj.mainProjectId === projectAfter[ATTR_MAIN_PROJ_ID])
        if (mainProject1 !== mainProject2) {
            prosLogErr("MP error mainProject1:", mainProject1, "mainProject2:", mainProject2)
            return
        }
        let afterProjectIndex = mainProject1.projects
            .findIndex(project => project[ATTR_AWS_PROJECT_ID] === projectAfter[ATTR_AWS_PROJECT_ID])
        if (afterProjectIndex < 0) {
            prosLogErr("Sub project not found for projectAfter:", projectAfter, "in main:", mainProject1)
            return
        }
        mainProject1.projects = mainProject1.projects
            .filter(project => project[ATTR_AWS_PROJECT_ID] !== movedProj[ATTR_AWS_PROJECT_ID])
        // Find index again after removal
        afterProjectIndex = mainProject1.projects
            .findIndex(project => project[ATTR_AWS_PROJECT_ID] === projectAfter[ATTR_AWS_PROJECT_ID])
        afterProjectIndex += 1
        if (afterProjectIndex >= mainProject1.projects.length) {
            mainProject1.projects.push(movedProj)
        } else {
            mainProject1.projects.splice(afterProjectIndex, 0, movedProj)
        }
        this.setState({filteredList: newList})
    }

    moveSubProject(movedProj, projectAfter) {
        if (getObjAttr(movedProj, ATTR_CUSTOMER_GROUP) !== getObjAttr(projectAfter, ATTR_CUSTOMER_GROUP)) {
            prosAppNotif("Osaprojektia ei voi siirtää eri asiakastunnuksen projektiin", 'warning', true)
            return
        }
        if (getObjAttr(movedProj, ATTR_MAIN_PROJ_ID) !== getObjAttr(projectAfter, ATTR_MAIN_PROJ_ID)) {
            if (!prosConnect.hasPermissionTo('moveProject', movedProj, movedProj, false)) {
                prosAppNotif("Ei käyttöoikeutta siirtää toiseen projektiin");
                return
            }
            let oldMain = this.state.filteredList.find(mp => mp.mainProjectId === movedProj[ATTR_MAIN_PROJ_ID])
            let newMain = this.state.filteredList.find(mp => mp.mainProjectId === projectAfter[ATTR_MAIN_PROJ_ID])
            this.moveSubProjectToMain(oldMain, newMain, movedProj, projectAfter)
        }
        this.moveSubProjectAfter(movedProj, projectAfter)
    }

    /**
     * Dragged obj this.state.srcProjDrag is sub-project
     * dropObj on top of dropped can be a sub-project or a main project
     */
    onDropProj (ev, dropObj) {
        ev.stopPropagation()   // required as subproject is a child element of main project
        this.onDragLeave(ev)
        if (!this.isValidDrop(dropObj)) {
            return
        }
        const isSrcMainProject = this.isMainProject(this.state.srcProjDrag)
        const isDstMainProject = this.isMainProject(dropObj)
        let movedProj = this.state.srcProjDrag
        let projectAfter = dropObj
        this.setState({srcProjDrag: null})
        if (isSrcMainProject && isDstMainProject) {
            this.moveMainProject(movedProj, projectAfter)
        } else if (isDstMainProject && !isSrcMainProject) {
            let oldMain = this.state.filteredList.find(mp => mp.mainProjectId === movedProj[ATTR_MAIN_PROJ_ID])
            let newMain = this.state.filteredList.find(mp => mp.mainProjectId === projectAfter.mainProjectId)
            this.moveSubProjectToMain(oldMain, newMain, movedProj, undefined)
        } else if (!isDstMainProject && !isSrcMainProject) {
            this.moveSubProject(movedProj, projectAfter)
        } else {
            // Should not happen when validating correctly - just in case indicate an error
            prosLogErr("rearrange project type conflict src:", this.state.srcProjDrag, "dst:", dropObj)
        }
    }

    onDragOver(ev, dropObj) {
        ev.stopPropagation()   // required as subproject is a child element of main project
        if (!this.isValidDrop(dropObj)) {
            return
        }
        // Show drop area
        if(ev.target.draggable) {
            ev.target.classList.add('drop-indicator')
        }
        // on drop is enabled by preventing default event handling
        ev.preventDefault()
    }

    onDragLeave(ev) {
        ev.preventDefault()
        if(ev.target.draggable) ev.target.classList.remove('drop-indicator')
    }

    tellParentToLoadProject(project) {
        this.cancelProjectActivationTimer()
        this.props.projectSelected(project.project_id)
        this.setState({pendingProjectId: undefined})
    }

    /**
     * User selected sub-project from list
     *      - set pending project ID to give user feedback about selection
     *      - wait until AWS API is not busy
     *      - call props to start loading project
     *      - or cancel if component closed ( user pressed project settings etc )
     */
    onProjectSelected(project) {
        if (this.state.isReordering) {
            prosAppNotif("Projektia ei voi valita kun järjestely on kesken")
            return
        }
        this.queueProjectActivation(project, true)
        this.props.closeSideBar()
    }

    queueProjectActivation(project, firstTime) {
        if (!isProjectsMounted) {
            return
        }
        if (!prosConnect.isAwsInterfaceBusy()) {
            this.tellParentToLoadProject(project)
            return
        }
        if (firstTime) {
            this.setState({pendingProjectId: project.project_id})
        }
        waitProjectActivationTimer = setTimeout(() => {
            this.queueProjectActivation(project)
        }, POLL_AWS_NOT_BUSY_MS);
    }

    cancelProjectActivationTimer() {
        clearTimeout(waitProjectActivationTimer)
        waitProjectActivationTimer = undefined
        this.setState({pendingProjectId: undefined})
    }

    renderSubProjects(mainProj, passiveSubs) {
        if (mainProj.projects.length > 0 && mainProj.ui_isOpen) {
            let activeSubs = mainProj.projects.filter(project => project[ATTR_PROJECT_STATE] === OBJ_STATE_ACT)
            const projList = [...activeSubs, ...passiveSubs].map((project) => {
                let isSubprojectsArchived = project[ATTR_PROJECT_STATE] === OBJ_STATE_PAS
                return <li
                        key={"projects__" + project.project_id}
                        onDragStart={(e) => this.onDragStartProj(e, project)}
                        draggable={this.state.isReordering && !isSubprojectsArchived ? true : null}
                        onDragOver={(e) => this.onDragOver(e, project)}
                        onDragLeave={(e) => this.onDragLeave(e)}
                        onDrop={(e) => {this.onDropProj(e, project)}}
                        onClick={(evt)=> {
                            evt.stopPropagation()
                            this.onProjectSelected(project)
                        }}
                        className={"display-flex"
                            + this.getProjectUiClass(project)
                            + (this.state.isReordering && mainProj.ui_isOpen ? " super-hilite" : "")
                        }
                    >
                        <span
                            tabIndex={0}
                        >{prosConnect.getProjectInfo(project)}</span>
                        {isSubprojectsArchived ? <i className={"ui-icon ui-icon-md ui-icon-outline-lock ui-icon_color-light"} /> : null}
                </li>
            })
            return <ul className={"project-container element-indented active"}>{projList.length === 0
                ? this.addNewSubprojectButton(mainProj) : projList}</ul>
        }
    }

    accordionHeaderClassToggle(mainProject, state) {
        mainProject.ui_isOpen = state
        this.setState({filteredList : this.state.filteredList})
    }

    // launchEditProjectUsers(mainProject) {
    //     let subProject = mainProject.projects.find(sp => sp.user_role === ROLE_ADMIN)
    //     if (subProject) {
    //         // give first subproject for which have admin rights PermissionManagement will load project & user list
    //         this.props.launchEditProjectUsers(subProject.project_id)
    //     }
    // }

    isNewMainProject(mainProject) {
        // True when is a new main project - no sub-projects yet - or all sub-projects been deleted
        if (!mainProject.projects) {
            return false
        }
        return (mainProject.projects.length < 1 ||
                mainProject.projects[0][ATTR_PROJECT_STATE] === OBJ_STATE_CREATE)
    }

    renderMainProjNav(mainProject) {
        if( ! mainProject.ui_isOpen || mainProject.customerGroup === "EXAMPLES") {
            return
        }
        const myProdect = mainProject.name.toUpperCase() === 'MYPRODECT'
        let editAdminProjects = !Array.isArray(mainProject.projects) ? [] :
            mainProject.projects.filter(project => prosConnect.hasPermissionTo('editAdmin', undefined, project, false))
        let permInspectAllProjects = !Array.isArray(mainProject.projects) ? false :
            mainProject.projects.filter(project => prosConnect.hasPermissionTo('excelExport', undefined, project, false)).length === mainProject.projects.length
        const noPermissions = editAdminProjects.length <= 0 && !this.isNewMainProject(mainProject)
        return <>
            {myProdect || (noPermissions && ! permInspectAllProjects) ? null
                : <BasicButton
                    icon={"arrow-right"}
                    iconColor={"light"}
                    iconSize={"md"}
                    action={() => {
                        this.accordionHeaderClassToggle(mainProject, true)
                        this.props.openMainProjectPage(mainProject, MAIN_VIEW_PROJECT_DASHBOARD, ! noPermissions)
                    }}
                    tooltip={["Tilanne", "tooltip-left_bottom"]}
                    selected={this.props.mainProjectId === mainProject.mainProjectId
                        && this.props.isMainProjectView
                        && this.props.currentProjectView === MAIN_VIEW_PROJECT_DASHBOARD
                    }
                />}
            {noPermissions ? null : this.mainProjectMenu(mainProject, noPermissions, myProdect)}
        </>
    }

    /**
     * Get list of main projects to show
     * @returns {T[]}   Hierarchical list of main projects and their sub projects filtering out
     *                  Examples and empty main projects when rearranging
     */
    projectsToShow() {
        const isReordering = this.state.isReordering
        function shouldShowMainproject(mainProj) {
            if (!isReordering) {
                return true
            }
            if (mainProj.customerGroup === "EXAMPLES") {
                // Do not show example projects when rearrange mode is in use
                return false
            }
            if (mainProj.projects.length === 1 && mainProj.projects[0][ATTR_OBJ_STATE] === "CREATE") {
                // Do not show empty main project that does not have yet any sub project
                return false
            }
            return true
        }
        return this.state.filteredList.filter(mainProj => shouldShowMainproject(mainProj))
    }

    renderMainProjItems() {
        if (this.state.filteredList.length < 1) {
            if (this.state.projectFilterText) {
                // no text filter match
                if(this.state.projectFilterText.length > 0) return <p className={"text-center padding"}>Ei tuloksia.</p>
                else return
            }
            // Notify about no items in list
            let note
            switch (this.state.projectView) {
                case OBJ_STATE_ACT: note = "Ei aktiivisia"; break
                case OBJ_STATE_PAS: note = "Ei arkistoituja"; break
                default: note = "Ei projekteja"
            }
            return <h6 className={"text-center color-light"}>{note}</h6>
        }

        return this.projectsToShow().map((mainProj, i) => {
            if(mainProj.mainProjectId === this.state.currentMainProjectId) mainProj.ui_isOpen = true
            let passiveSubs = mainProj.projects.filter(project => project[ATTR_PROJECT_STATE] === OBJ_STATE_PAS)
            return <div key={i}
                    onDrop={(e) => this.onDropProj(e, mainProj)}
                    onDragOver={(e) => this.onDragOver(e, mainProj)}
                    onDragLeave={(e) => this.onDragLeave(e)}
                    onDragStart={(e) => this.onDragStartProj(e, mainProj)}
                    draggable={this.state.isReordering && !mainProj.ui_isOpen ? true : null}
                    onClick={(evt)=> {
                        evt.stopPropagation()
                        this.accordionHeaderClassToggle(mainProj, !mainProj.ui_isOpen)
                    }}
                >
                <div
                    className={"main-project element-set-xs"
                        + (mainProj.ui_isOpen ? " open" : "")
                        + (this.state.isReordering && !mainProj.ui_isOpen ? " super-hilite" : "")
                    }
                    draggable={this.state.isReordering && mainProj.ui_isOpen ? false : null}
                >
                    <BasicButton
                        icon={mainProj.ui_isOpen ? "chevron-down" : "chevron-right"}
                        iconColor={"light"}
                        iconSize={"sm"}
                        label={mainProj.name}
                        action={() => {
                            this.accordionHeaderClassToggle(mainProj, !mainProj.ui_isOpen)
                        }}
                    />
                    {this.renderMainProjNav(mainProj)}
                </div>
                {this.renderSubProjects(mainProj, passiveSubs)}
            </div>
        })
    }

    startCreateProject(refProjectAttrs, projectCreateViewType, mainProjectId) {
        //Todo Tero: check as this didnt seem to do anything
        // if (refProjectAttrs) {
        //     this.setState({currentRefProjectId: refProjectAttrs.project_id})
        // }
        //Todo see todo below
        this.setState({
            currentMainProjectId: mainProjectId
        })
        // Restrict as a reference main projects for which user has permission to use as ref
        this.props.createProjectClicked(refProjectAttrs, projectCreateViewType)
    }

    mainProjectMenu(mainProject, noPermissions, myProdect) {
        const isCurrentProject = this.props.mainProjectId === mainProject.mainProjectId
            && this.props.isMainProjectView
        const isDashboardview = this.props.currentProjectView === MAIN_VIEW_PROJECT_DASHBOARD
        const menuItems = [
            {
                element: this.addNewSubprojectButton(mainProject)
            },
            {
                icon: "gear_color-light",
                text: "Projektin asetukset",
                action: ()=>{
                    this.props.openMainProjectPage(mainProject, MAIN_VIEW_MAIN_PRJ_SETTINGS, true)
                },
                selected: isCurrentProject && !isDashboardview
            }
        ]
        if (myProdect) {
            menuItems.pop()
        }
        return <DropdownMenu
            btnClass={noPermissions ? "3rd" : "primary"}
            btnType={""}
            values={menuItems}
            icon={"ellipsis-v"}
            hideArrow
            text={false}
            className={"ui-dropdown-align-right"}
            active={(isCurrentProject && !isDashboardview)
                || (this.props.creatingNewProject && this.state.currentMainProjectId === mainProject.mainProjectId
            )}
        />
    }

    addNewSubprojectButton(mainProj, isCurrentProject){
        if (!mainProj.ui_isOpen) {
            return null
        }
        if (!mainProj.referenceToCreateNew) {
            return null
        }
        if (this.state.isReordering) {
            return null
        }
        let currentProject = prosConnect.getActiveProject()
        let refProjectAttrs
        if (currentProject &&
            prosConnect.hasPermissionTo("addProject", undefined, undefined, false) &&
            currentProject.getAttr(ATTR_MAIN_PROJECT_NAME).toUpperCase() === mainProj.name.toUpperCase() &&
            currentProject.getAttr(ATTR_MAIN_PROJ_ID) === mainProj.mainProjectId) {
            refProjectAttrs = currentProject.attrs
        } else {
            refProjectAttrs = mainProj.referenceToCreateNew
        }
        if (!refProjectAttrs) {
            return null
        }
        return <BasicButton
            icon={"folder-plus"}
            iconColor={"light"}
            label={"Lisää osaprojekti"}
            action={()=> {
                this.props.closeSideBar()
                this.startCreateProject(refProjectAttrs, MAIN_VIEW_CREATE_NEW_SUBPROJECT, mainProj.mainProjectId)
            }}
            selected={isCurrentProject && this.props.creatingNewProject}
        />
    }


    toggleAllMainProjects(open){
        this.state.filteredList.forEach(proj=> {
            proj.ui_isOpen = open
        })
        this.setState({
            openAll: open,
            filteredList: this.state.filteredList
        })
    }

    renderListTop(){
        let hasMainProjects = userHasMainProjects(this.state.mainProjects)
        if(!hasMainProjects){
            return <>
                <BasicButton
                    btnClass={"primary"}
                    label={"Tilaa ensimmäinen projekti"}
                    icon={"plus"}
                    action={()=>{
                        this.props.startCreateNewMainProject()
                    }}
                    className={"margin"}
                    selected
                />
            </>
        }
        if(!prosConnect.userHasSubProjects(this.state.mainProjects)) return null
        if(this.state.isReordering){
            const menuValues = [
                {
                    text: 'Tallenna järjestys',
                    action: ()=> this.toggleRearrangeMode(true)
                },
                {
                    text: 'Peru muutokset',
                    action: ()=> {
                        this.setState({isReordering: false})
                        this.refreshProjects(true)
                        this.setTextFilter('')
                    }
                },
            ]
            return <div className={"padding-sm width-100 margin-0"}>
                <DropdownMenu
                    btnClass={"primary"}
                    values={menuValues}
                    text={"Tallenna järjestys"}
                    icon={"check"}
                    className={"width-100"}
                    active
                />
            </div>
        }

        let menuItems = [
            {
                text: "Avaa kaikki",
                icon: "chevron-down_color-light",
                action: ()=> this.toggleAllMainProjects(true)
            },{
                text: "Sulje kaikki",
                icon: "chevron-up_color-light",
                action: ()=> this.toggleAllMainProjects(false)
            },{
                text: (this.state.projectView === 'all' ? "Piilota" : "Näytä") + " arkistoidut",
                icon: "outline-lock_color-light",
                action: async ()=>{
                    let newMode = this.state.projectView === OBJ_STATE_ACT ? 'all' : OBJ_STATE_ACT
                    this.setState({
                        projectView: newMode
                    })
                    await this.makeMainProjectList(newMode)
                },
                selected: this.state.projectView !== OBJ_STATE_ACT
            }
        ]
        const reorderDisabled = this.state.projectFilterText || this.state.projectView === "all"
        menuItems.push({
            text: this.state.isReordering ? "Tallenna järjestys" : "Järjestele",
            icon: "reorder" + (!reorderDisabled ? "_color-light" : ""),
            action: ()=> {
                this.setTextFilter('')
                this.toggleRearrangeMode(false)
            },
            btnType: reorderDisabled ? "locked" : null,
            notifMsg: reorderDisabled ? "Järjestely estetty, koska haku on aktiivinen tai arkistoidut ovat näkyvillä" : null
        },)
        return <div className={"element-set-xs width-100"}>
            <TextButton
                label={"Suodata"}
                btnClass={"primary"}
                icon={"search_color-light"}
                placeholder={"Suodata projekteja"}
                value={this.state.projectFilterText}
                inputType={"search"}//go in pairs
                keepActive={true}//go in pairs
                onSubmit={val => {
                    this.setTextFilter(val)
                }}
                disabled={this.state.isReordering}
                isActive={this.state.projectFilterText.length > 0}
            />
            {this.renderRefreshUi()}
            <DropdownMenu
                values={menuItems}
                btnClass={"3rd"}
                text={false}
                icon={"ellipsis-v_color-light"}
                className={"ui-dropdown-align-right"}
                hideArrow
                active={this.state.isReordering || this.state.projectView !== OBJ_STATE_ACT}
                tooltip={this.state.isReordering ? ["Tallenna muutokset", "tooltip-left tooltip-active tooltip-notice"] : null}
            />
        </div>
    }

    async confirmSubProjectChanges(confirmChanges, newOrder) {
        let changes = confirmChanges.map(project => { return {
            [ATTR_AWS_PROJECT_ID]: project[ATTR_AWS_PROJECT_ID],
            [ATTR_OBJ_ID]: OBJ_TYPE_PRJ,
            [ATTR_MAIN_PROJ_ID]: project[ATTR_MAIN_PROJ_ID],
            [ATTR_MAIN_PROJECT_NAME]: project[ATTR_MAIN_PROJECT_NAME]
        }})
        prosAppNotif("Osaprojektien siirtäminen toiseen pääprojektiin kestää hetken aikaa..")
        await prosConnect.updateItemsAttributes(changes, true)
        prosConnect.saveUserSettings("project_order", newOrder)
        this.setState ({isReordering: false})
        setTimeout(() => {
            prosAppNotifDismiss()
            prosPopupCloseAll(this)
            this.refreshProjects(true)
        }, 3000)
    }

    closeSubProjectChangesPrompt() {
        this.refreshProjects(true)
    }

    async toggleRearrangeMode(isReordering) {
        if (isReordering) {
            let confirmChanges = []
            let newOrder = this.projectsToShow()
                .map(mainProj => {
                    return {
                        mpid: mainProj.mainProjectId,
                        pids: mainProj.projects.map(proj => {
                            let origIds = this.originalSubProjectMainProjects
                                .find(origIds => origIds[ATTR_AWS_PROJECT_ID] === proj[ATTR_AWS_PROJECT_ID])
                            if (origIds && origIds[ATTR_MAIN_PROJ_ID] !== proj[ATTR_MAIN_PROJ_ID]) {
                                // Need to confirm changes between main projects
                                confirmChanges.push(proj)
                            }
                            return proj[ATTR_AWS_PROJECT_ID]
                        })
                    }
            })
            if (confirmChanges.length) {
                BasicModal('Vahvista osaprojektien siirto',
        'Vahvista järjestysmuutokset. Siirretään ' + confirmChanges.length + ' osaprojektia toiseen pääprojektiin',
                    {
                        action: ()=> {
                            this.confirmSubProjectChanges(confirmChanges, newOrder)
                        },
                        cancelCallback: ()=> this.closeSubProjectChangesPrompt()
                    }
                )
                this.setState ({isReordering: false})
            } else {
                prosConnect.saveUserSettings("project_order", newOrder)
                this.refreshProjects(true)
                this.setState ({isReordering: false})
            }
        } else {
            this.setState ({isReordering: true})
        }
    }

    renderRefreshUi() {
        return <BasicButton
            icon={"sync_color-light"}
            title={"Päivitä projektilista"}
            tooltip={["Päivitä projektilista", "tooltip-left_bottom"]}
            action={()=> {
                this.setState({
                    projectFilterText: ''
                })
                this.refreshProjects(true)
            }}
            loading={this.state.isRefresh}
            disabled={this.state.isReordering}
        />
    }

    render() {
        if (this.state.isLoading) {
            return <div className={"projects-container"}>
                <LoadingAnimation color={'var(--color-gray-20)'}/>
            </div>
        }
        return <div className={"projects-container"}>
            {this.renderListTop()}
            {this.renderMainProjItems()}
        </div>
    }
}
